var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCourse = function SvgCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.096 14.967"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.806 0A2.807 2.807 0 0 0 0 2.806v9.354a2.807 2.807 0 0 0 2.806 2.806h9.354a.935.935 0 1 0 0-1.871v-1.87a.934.934 0 0 0 .935-.935V.935A.934.934 0 0 0 12.16 0H2.806Zm0 11.225h7.483V13.1H2.806a.935.935 0 1 1 0-1.871Zm.935-7.016a.469.469 0 0 1 .468-.468h5.613a.468.468 0 0 1 0 .935H4.209a.469.469 0 0 1-.467-.467Zm.468 1.4h5.613a.468.468 0 0 1 0 .935H4.209a.468.468 0 0 1 0-.935Z"
  })));
};
export default SvgCourse;